var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8118 0.000261574C14.5067 0.00632407 13.2604 0.117637 12.1638 0.311699C8.93321 0.882449 8.34665 2.07701 8.34665 4.28007V7.18964H15.9808V8.15945H8.34665H5.48159C3.2629 8.15945 1.32009 9.49301 0.712464 12.0299C0.011526 14.9378 -0.0195365 16.7524 0.712464 19.7888C1.25515 22.0488 2.55109 23.6592 4.76978 23.6592H7.39459V20.1713C7.39459 17.6514 9.57478 15.4288 12.1638 15.4288H19.7891C21.9117 15.4288 23.6062 13.6811 23.6062 11.5494V4.28007C23.6062 2.2112 21.8608 0.657012 19.7891 0.311699C18.4777 0.0933866 17.1169 -0.00580093 15.8118 0.000261574ZM11.6833 2.34039C12.4718 2.34039 13.1158 2.99489 13.1158 3.79957C13.1158 4.60145 12.4718 5.24989 11.6833 5.24989C10.8919 5.24989 10.2508 4.60145 10.2508 3.79957C10.2508 2.99482 10.8919 2.34039 11.6833 2.34039Z",
    fill: "url(#paint0_linear_810_193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5585 8.15949V11.5495C24.5585 14.1777 22.3302 16.3898 19.7894 16.3898H12.164C10.0754 16.3898 8.34692 18.1774 8.34692 20.2692V27.5386C8.34692 29.6074 10.146 30.8244 12.164 31.4179C14.5806 32.1285 16.898 32.2569 19.7894 31.4179C21.7113 30.8615 23.6064 29.7416 23.6064 27.5386V24.629H15.9811V23.6591H23.6064H27.4236C29.6422 23.6591 30.4691 22.1116 31.2407 19.7887C32.0377 17.3973 32.0038 15.0976 31.2407 12.0299C30.6924 9.82111 29.6451 8.15936 27.4236 8.15936H24.5585V8.15949ZM20.2699 26.5687C21.0612 26.5687 21.7024 27.2172 21.7024 28.0191C21.7024 28.8238 21.0612 29.4783 20.2699 29.4783C19.4813 29.4783 18.8374 28.8238 18.8374 28.0191C18.8373 27.2172 19.4812 26.5687 20.2699 26.5687Z",
    fill: "url(#paint1_linear_810_193)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_810_193",
    x1: -0.573166,
    y1: 0.910037,
    x2: 17.0344,
    y2: 15.9256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_810_193",
    x1: 23.6596,
    y1: 25.2595,
    x2: 17.3453,
    y2: 16.4046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPython);
export default __webpack_public_path__ + "static/media/icon_python.f43d0499af1bc71be242f7d0e5ec1178.svg";
export { ForwardRef as ReactComponent };